import { render, staticRenderFns } from "./interests.vue?vue&type=template&id=331e77b4&scoped=true"
import script from "./interests.vue?vue&type=script&lang=js"
export * from "./interests.vue?vue&type=script&lang=js"
import style0 from "./interests.vue?vue&type=style&index=0&id=331e77b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e77b4",
  null
  
)

export default component.exports